import { B100, B400, B500, DN0, DN400, DN70, DN900, G50, G500, N0, N40, N800, R400, R50, R500 } from '@atlaskit/theme/colors';
export var backgroundColors = {
  added: {
    light: "var(--ds-background-success, ".concat(G50, ")"),
    dark: "var(--ds-background-success, ".concat(G50, ")")
  },
  default: {
    light: "var(--ds-background-neutral, ".concat(N40, ")"),
    dark: "var(--ds-background-neutral, ".concat(DN70, ")")
  },
  important: {
    light: "var(--ds-background-danger-bold, ".concat(R400, ")"),
    dark: "var(--ds-background-danger-bold, ".concat(R400, ")")
  },
  primary: {
    light: "var(--ds-background-brand-bold, ".concat(B400, ")"),
    dark: "var(--ds-background-brand-bold, ".concat(B100, ")")
  },
  primaryInverted: {
    light: "var(--ds-surface, ".concat(N0, ")"),
    dark: "var(--ds-surface, ".concat(DN400, ")")
  },
  removed: {
    light: "var(--ds-background-danger, ".concat(R50, ")"),
    dark: "var(--ds-background-danger, ".concat(R50, ")")
  }
};
export var textColors = {
  added: {
    light: "var(--ds-text-success, ".concat(G500, ")"),
    dark: "var(--ds-text-success, ".concat(G500, ")")
  },
  default: {
    light: "var(--ds-text, ".concat(N800, ")"),
    dark: "var(--ds-text, ".concat(DN900, ")")
  },
  important: {
    light: "var(--ds-text-inverse, ".concat(N0, ")"),
    dark: "var(--ds-text-inverse, ".concat(N0, ")")
  },
  primary: {
    light: "var(--ds-text-inverse, ".concat(N0, ")"),
    dark: "var(--ds-text-inverse, ".concat(DN0, ")")
  },
  primaryInverted: {
    light: "var(--ds-text-brand, ".concat(B500, ")"),
    dark: "var(--ds-text-brand, ".concat(DN0, ")")
  },
  removed: {
    light: "var(--ds-text-danger, ".concat(R500, ")"),
    dark: "var(--ds-text-danger, ".concat(R500, ")")
  }
};